/* Block - Tab (carousel).
 *
 * Imports the block css.
 * Contains block-specific functionality.
 *
 * @file single
 *
 */
/* eslint-disable-next-line */
import styles from "./block-tab.scss";
import rsCarousel from '../../js/component/_carousel-tabs';

const carousels = Array.from(document.querySelectorAll('body:not(.wp-admin) .rs-tabs-carousel'));

rsCarousel.init(carousels);
